import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import AddOpeningComp from "./AddOpeningComp";
import { convertToLowestUnit, ExportAvailableInCSVForReports, exportFromula, GetUpdatedDelivered, mapUnits, formatUnitsForReport } from "../../../../helpers/units";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import BatchWithdrawModal from "../../../../components/BatchWithdrawModal";
import { findEarliestExpiringBatches } from "../../../../helpers/batchWithdrawl";
import ExpiryChangePopup from "../../../../components/ExpiryChangeModal";

const ViewInventory = (props) => {

  const { SearchBar } = Search;
  const is_manual_entry_allowed = localStorage.getItem("is_manual_entry_allowed") == "true";

  useEffect(() => {
    loadItems();
    loadCategories();
  }, []);
  
  const [allCategories, setAllCategories] = useState([]);
  const loadCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemcategories/getall";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [allItems, setAllItems] = useState([]);
  const [allItemsFiltered, setAllItemsFiltered] = useState([]);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const itemsRequestId = useRef(0);
  const loadItems = async () => {
    const requestId = ++itemsRequestId.current;
    setIsLoadingItems(true);
    let url = process.env.REACT_APP_BASEURL + "stores/getinventory";
    try {
      const response = await postSubmitForm(url, {
        type: "item",
        include_cost_price: false,
      });
      if (requestId !== itemsRequestId.current) return;
      if (response && response.status === 1) {
        setAllItems(response.data);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== itemsRequestId.current) return;
      showNotification(error, "Error");
    } finally {
      if (requestId === itemsRequestId.current) {
        setIsLoadingItems(false);
      }
    }
  };
  const [selectedCategory, setSelectedCategory] = useState("All");
  useEffect(() => {
    setTablePage(1);
    if (selectedCategory === "All") {
      setAllItemsFiltered(allItems);
    } else {
      setAllItemsFiltered(
        (allItems || []).filter((item) => item.category === selectedCategory)
      );
    }
  }, [allItems, selectedCategory]);

  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItem_Transactions, setSelectedItem_Transactions] = useState(
    []
  );
  const handleViewDetailsClick = async (row) => {
    let url =
      process.env.REACT_APP_BASEURL + "branchiteminventories/get_by_item_id";
    // console.log({ item_id: row.item_id });
    const response = await postSubmitForm(url, {
      item_id: row.item_id,
      inventory_type: "Kitchen",
    });
    // console.log(response);
    if (response && response.status === 1) {
      setSelectedItem_Transactions(response.data);
      setSelectedItem(row);

      setTransactionsModal(true);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [selectedItemToAdd, setSelectedItemToAdd] = useState();
  const [addInventoryModal, setAddInventoryModal] = useState(false);
  function editFormatter(cell, row) {
    return (
      <>
        <span className="text-info">
          <i
            className="mdi mdi-text-box-search font-size-15 mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleViewDetailsClick(row);
            }}
          ></i>
        </span>{" "}
        <span style={{ display: is_manual_entry_allowed ? 'inline' : 'none' }}>
          <i
            className="mdi mdi-cart-plus font-size-15"
            title="Add Opening Inventory"
            hidden={!row.is_active}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedItemToAdd(row);
              setAddInventoryModal(!addInventoryModal);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },

    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      dataField: "threshold",
      text: props.t("Threshold"),
      formatter: (cell, row) => {
        return (
          row.threshold + " " + row.unit_for_threshold
        )
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      sort: true,
      formatter: (cell, row) => {
        let threshold = convertToLowestUnit(row?.unit_levels, [{ unit: row?.unit_for_threshold, value: row?.threshold }]);
        let totalAvailable = convertToLowestUnit(row?.unit_levels, row?.available)

        if (totalAvailable <= threshold) {
          return (
            <span
              style={{
                whiteSpace: "normal",
                display: "inline-block",
                maxWidth: "100%",
              }}
              className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1"
            >
              {formatUnitsForReport(row?.available, row?.unit_levels)}
            </span>
          );
        } else {
          return formatUnitsForReport(row.available, row.unit_levels);
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      text: props.t("Action"),
      formatter: editFormatter,
      csvExport: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const [selectedBatch, setSelectedBatch] = useState();
  const [withdrawModal, setWithrdrawModal] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const handleWithdrawClicked = async (quantity) => {
    if (quantity.length <= 0) {
      showNotification("Please select atleast one unit ", "Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(quantity, selectedItem.unit_levels)
    let WithdrawQuantity = convertedQuantity?.map((item) => ({
      unit: item.unit,
      value: Number(item.value)
    }))
    const isInvalidTransfer = WithdrawQuantity.some(item => item.value === 0 && item.isChecked);

    if (isInvalidTransfer) {
      showNotification("Cannot withdraw products with 0 value and checked", "Warning");
      return;
    }
    setIsLoading(true)
    const object = {
      branchiteminventory_id: selectedBatch._id,
      quantity: WithdrawQuantity,
    };
    let url = process.env.REACT_APP_BASEURL + "branchiteminventories/withdraw";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      setIsLoading(false)
      showNotification(response.message, "Success");
      loadItems();
      setTransactionsModal(!transactionsModal);
      setWithrdrawModal(!withdrawModal);
      return true
    } else {
      setIsLoading(false)
      showNotification(response.message, "Error");
      return false
    }
  };
  function checkValues(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value > 0) {
        return true;
      }
    }
    return false;
  }
  const [discardWasteModal, setDiscardWasteModal] = useState();
  const handleDiscardAsWaste = async (quantity) => {
   try {
    if(quantity.length<=0){
      showNotification("Please enter a valid quantity ","Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(quantity,selectedItem.unit_levels)
    const isInvalidTransfer = convertedQuantity.every(item => item.value == 0 );
    if (isInvalidTransfer) {
      showNotification("Cannot discard product with value 0 and checked", "Warning");
      return;
    }
    const object = {
      inventory_id: selectedBatch._id,
      quantity: convertedQuantity.map(({unit,value})=>({unit,value})),
    };
    setIsLoading(true)
    let url =  process.env.REACT_APP_BASEURL + "branchiteminventories/mark_wasted";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      showNotification(response.message, "Success");
      setTransactionsModal(!transactionsModal);
      setDiscardWasteModal(!discardWasteModal);
      loadItems();
      setSelectedBatch()
      return true
    } else {
      showNotification(response.message, "Error");
      return false
    }
   } catch (error) {
    console.log(error);
   } finally {
    setIsLoading(false)
   }
  };

  const [dateChangeModal, setDateChangeModal] = useState(false);
  const [selectedRowForDateChange, setSelectedRowForDateChange] = useState(null);
  const handleExpiryDateChange = async (newDate) => {
    try {
      if (!newDate) {
        showNotification("Please select a valid date", "Warning");
        return;
      }
      preloader(true);
      const url =
        process.env.REACT_APP_BASEURL +
        "storeiteminventories/update_expiry_date";
      const payload = {
        id: selectedRowForDateChange._id,
        batch: selectedRowForDateChange.batch,
        expiry_date: moment(newDate).format("YYYY-MM-DD"),
      };
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        showNotification("Expiry date updated successfully", "Success");
        handleViewDetailsClick(selectedItem);
        setDateChangeModal(false);
        setSelectedRowForDateChange(null);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification("Error updating expiry date", "Error");
    } finally {
      preloader(false);
    }
  };
  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Supplier"),
      dataField: "supplier_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    // {
    //   dataField: "cost_price",
    //   text: props.t("Cost Price"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "remarks",
    //   text: props.t("Remarks"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        if (row.expiry_date) {
          return moment(row.expiry_date).format("DD/MM/YYYY");
        } else {
          return (
            <>
              <span className="text-info d-flex align-items-center justify-content-center"
                style={{cursor:"pointer"}}
                onClick={() => {
                  setSelectedRowForDateChange(row);
                  setDateChangeModal(true);
                }}
              >
                <i className="bx bxs-edit font-size-15" />
              </span>
            </>
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "",
      text: props.t("Entry Date"),
      sort: false,
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      text: props.t("Withdraw"),
      formatter: (cell, row) => {
        // Finding earliest expiring batches
        const earliestBatches = findEarliestExpiringBatches(selectedItem_Transactions || []);
        // Checking if current row is in earliest batches
        const isEarliestBatch = earliestBatches.some(
          batch => batch._id === row._id
        );
        // Check if the batch has quantity
        const hasQuantity = row.quantity.some(q => q.value > 0);
        const isDisabled = row.expiry_date && !(isEarliestBatch && hasQuantity);
        return (
          <span className={`text-info ${isDisabled ? 'text-muted' : ''}`}>
            <i
              className={`bx bx-download font-size-22 ${isDisabled ? 'text-secondary' : ''}`}
              title="Withdraw"
              style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled ? 0.5 : 1
              }}
              onClick={() => {
                if (!isDisabled) {
                  setSelectedBatch(row);
                  setWithrdrawModal(!withdrawModal);
                }
              }}
            ></i>
          </span>
        );
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Mark Wasted"),
      formatter: (cell, row) => {
        return checkValues(row.quantity) ? (

          <span className="text-info">
            <i
              className="bx bxs-trash font-size-22"
              title="Move to Waste"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedBatch(row);
                setDiscardWasteModal(!withdrawModal);
              }}
            ></i>
          </span>
        ) : (
          <span className="text-info">Out of stock</span>
        );
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };
  const table_pagination_options = {
    ...pagination_options,
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page) => setTablePage(page),
    onSizePerPageChange: (sizePerPage, page) => {
      setPageSize(sizePerPage);
      setTablePage(page);
    },
  };

  const handleDownload = async () => {
    const fileName = "items_inventory";
    const exportType = "xls";

    let data_to_export = allItemsFiltered;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          name: v.name,
          category: v.category,
          sub_category: v.sub_category,
          formula: v.unit_levels && exportFromula(v.unit_levels),
          threshold: v.threshold + " " + v.unit_for_threshold,
          available: v.available.length > 0 ? ExportAvailableInCSVForReports(v.available) : " "
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Inventory")}
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("View Inventory")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all items in your inventory here")}
                  </CardSubtitle>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allItemsFiltered || []}
                      columns={columns}
                      search
                      exportCSV
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}>
                              <select
                                name="category"
                                className="form-control"
                                value={selectedCategory}
                                onChange={(e) => {
                                  setSelectedCategory(e.target.value);
                                }}
                              >
                                <option value="All">All</option>
                                {allCategories &&
                                  allCategories.map((category) => {
                                    return (
                                      <option
                                        key={category._id || category.category}
                                        value={category.category}
                                      >
                                        {category.category}
                                      </option>
                                    );
                                  })}
                              </select>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(table_pagination_options)}
                            noDataIndication={
                              isLoadingItems ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="xl"
                    // style={{
                    //   width: "960px",
                    //   maxWidth: "970px",
                    // }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Item Name: {selectedItem && selectedItem.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedItem && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedItem_Transactions &&
                                          selectedItem_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* withdraw modal start  */}
                  <BatchWithdrawModal
                    isOpen={withdrawModal}
                    toggle={() => { setWithrdrawModal(false); setSelectedBatch() }}
                    onSubmit={handleWithdrawClicked}
                    item={selectedItem}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                  {/* withdraw modal end  */}

                   {/* ---Waste Modal Start--- */}
                   <BatchWithdrawModal
                    isOpen={discardWasteModal}
                    toggle={()=>{setDiscardWasteModal(false);setSelectedBatch()}}
                    onSubmit={handleDiscardAsWaste}
                    item={selectedItem}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                 
                   {/* ---Waste Modal End--- */}

                  {/* add inventory modal starts */}
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={addInventoryModal}
                    toggle={() => setAddInventoryModal(!addInventoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setAddInventoryModal(!addInventoryModal)}
                    >
                      Add Inventory
                    </ModalHeader>
                    <ModalBody>
                      <AddOpeningComp
                        isRefreshData={true}
                        refreshData={loadItems}
                        selectedItem={selectedItemToAdd}
                        handleClosePopup={() =>
                          setAddInventoryModal(!addInventoryModal)
                        }
                      />
                    </ModalBody>
                  </Modal>

                  {/* add inventory modal ends */}

                                    {/* ---Expiry Date Modal Start--- */}
                                    <ExpiryChangePopup
                    isOpen={dateChangeModal}
                    toggle={() => {
                      setDateChangeModal(false);
                      setSelectedRowForDateChange(null);
                    }}
                    onSubmit={handleExpiryDateChange}
                    initialDate={selectedRowForDateChange?.expiry_date}
                    title="Change Expiry Date"
                  />
                  {/* ---Expiry Date Modal End--- */}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
